import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Seo from './Seo';
import ProductSidebar from './ProductSidebar';
import { useUser } from '../contexts/UserContext';
import ResumeBuilderStudio from './ResumeBuilderStudio';
import './ResumeBuilderLanding.css';

const ResumeStudioPage = () => {
  const navigate = useNavigate();
  const { user } = useUser();

  // Auth modal lives on the homepage; route there with a flag when needed.
  const setShowAuthModal = useCallback((show) => {
    if (show) navigate('/?openLogin=1');
  }, [navigate]);

  return (
    <div className="rbl-page">
      <Seo
        title="Resume Studio — Build Your ATS-Ready Resume"
        description="Edit on the left, watch your resume render live on the right, and export a clean ATS-ready DOCX in minutes."
        path="/resume-studio"
      />
      <Header setShowAuthModal={setShowAuthModal} />
      <ProductSidebar user={user} setShowAuthModal={setShowAuthModal} />

      <ResumeBuilderStudio setShowAuthModal={setShowAuthModal} />
    </div>
  );
};

export default ResumeStudioPage;
